import { render, staticRenderFns } from "./LanguageDetector.vue?vue&type=template&id=45ab2ff2&"
import script from "./LanguageDetector.vue?vue&type=script&lang=js&"
export * from "./LanguageDetector.vue?vue&type=script&lang=js&"
import style0 from "./LanguageDetector.vue?vue&type=style&index=0&id=45ab2ff2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports